import { Box, SxProps, Theme, useTheme } from "@mui/material";
import React from "react";
import Typography from "../typography";

type Step = {
  label: string;
};

type ProgressStepsProps = {
  steps: Step[];
  currentStep: number; // 0-based index
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
};

// Height of the desktop (all-labels) layout, which callers subtract from the
// page height to reserve room for the absolutely positioned bar. Below `sm` the
// bar collapses to a single line and sits in normal flow, so it does not apply.
export const progressStepComponentHeight = 147;

export const ProgressSteps: React.FC<ProgressStepsProps> = ({
  steps,
  currentStep,
  style = {},
  sx,
}) => {
  const theme = useTheme();
  const progressPercent = ((currentStep + 1) / steps.length) * 100;

  return (
    <Box
      style={style}
      sx={{
        width: "100%",
        boxSizing: "border-box",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: { xs: "block", sm: "none" },
          marginBottom: theme.spacing(1),
        }}
      >
        <Typography
          variant="body2"
          style={{ fontWeight: 600 }}
          sx={{ fontSize: "0.9rem" }}
        >
          {`Step ${currentStep + 1} of ${steps.length} — ${steps[currentStep]?.label ?? ""}`}
        </Typography>
      </Box>

      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          justifyContent: "space-between",
          marginBottom: theme.spacing(1),
        }}
      >
        {steps.map((step, idx) => (
          <Typography
            key={`${step.label}-${idx}`}
            variant="body2"
            style={{
              flex: 1,
              textAlign: "center",
              fontWeight: 600,
            }}
            sx={{ fontSize: { sm: "0.85em", md: "1em" } }}
          >
            {step.label}
          </Typography>
        ))}
      </Box>
      <div
        style={{
          border: "1px solid #333",
          height: "20px",
          padding: "3px",
          borderRadius: "2px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${progressPercent}%`,
            backgroundColor: "#F89B1F",
            height: "100%",
            transition: "width 0.3s ease",
          }}
        />
      </div>
    </Box>
  );
};
